import React, { Component } from 'react'
import { observer } from 'mobx-react'

import MetricsStore from './MetricsStore'
import Input from '../../../form/Input'
import Button from '../../../../UniformComponents/Button'
import Select from '../../../form/Select'
import Typography from '../../../../UniformComponents/Typography'

@observer
class Metrics extends Component {
    constructor(props) {
        super(props)
        this.store = props.store
        this.metricsStore = new MetricsStore(this.store)
    }

    componentDidMount() {
        this.setupBreadcrumbs()
        this.metricsStore.fetchMetrics()
    }

    setupBreadcrumbs() {
        this.store.breadcrumbs = [
            { name: 'intranet', url: '/intranet', title: 'Intranet' },
            { name: 'metrics', url: '/intranet/metrics', title: 'Metrics' },
        ]
    }

    renderMetricsInputs() {
        const { language, metrics } = this.metricsStore
        const { handleInput, handleDeleteMetric } = this.metricsStore

        return metrics.map((metric, index) => (
            <div className="metricInputRow" key={metric.id}>
                <Input
                    type="text"
                    value={
                        metric.value[language.value] === undefined
                            ? metric.value.en_GB
                            : metric.value[language.value]
                    }
                    onChange={(e) => handleInput(e, index)}
                />

                <i className="fal fa-trash" onClick={() => handleDeleteMetric(index)} />
            </div>
        ))
    }

    render() {
        const {
            language, updateLanguage, handleSubmit, handleAddMetric,
        } = this.metricsStore
        const { store } = this

        return (
            <div id="metrics">
                <div className="metricsContainer">
                    <div className="languageWrapper">
                        <Select label="Language" value={language} options={store.languages} onBlur={updateLanguage} />
                    </div>

                    <Typography type="h4">
                        Metric List - here you add / edit metrics used within ROO
                    </Typography>

                    <Typography>ROO Metrics</Typography>

                    <br />

                    <div className="metricsInputsContainer">
                        {this.renderMetricsInputs()}
                        <Button
                            cssClass="regular primary"
                            onClick={handleAddMetric}
                        >
                            Add New Metric
                        </Button>
                    </div>

                    <Button
                        cssClass="regular primary"
                        onClick={handleSubmit}
                    >
                        Submit
                    </Button>
                </div>
            </div>
        )
    }
}

export default Metrics
